import requester from '@/services/requester'
import env from '@/.env.js'
import session from './session'
import store from '@/store'

const BACKEND_API_V1_URL = env.endpoint_backend

export default {
    async authenticate(parameters) {
        return requester.post(
            `${BACKEND_API_V1_URL}/users/authenticate`,
            parameters
        )
    },

    async refreshToken(parameters) {
        return requester.post(
            `${BACKEND_API_V1_URL}/users/refresh-token`,
            parameters
        )
    },

    registration(parameters) {
        return requester.post(
            `${BACKEND_API_V1_URL}/users/register`,
            parameters
        )
    },

    retrieveUserConfigurations(parameters) {
        return requester.post(
            `${BACKEND_API_V1_URL}/userConfigurations`,
            parameters
        )
    },

    async signup(parameters) {
        return await this.registration(parameters)
    },

    async login(credentials) {
        let response = await this.authenticate(credentials)

        if (response.status === 200) {
            await session.saveSession(response.data.results)
            await this.getUserConfigurations()
        }

        return response.data
    },

    async restoreAuthentication() {
        let token = session.getToken()
        try {
            if (token) {
                let response = await this.refreshToken()
                if (response.data.status === 'success') {
                    let user = response.data.data[0].user
                    user.token = response.data.data[0].token
                    user.refreshToken = response.data.data[0].refreshToken
                    await session.saveSession([user])
                    await this.getUserConfigurations()
                }
            }
        } catch (e) {
            console.log(e)
        }

        return true
    },

    async getUserConfigurations() {
        let configResponse = await this.retrieveUserConfigurations()

        if (configResponse.data.status === 'success') {
            const config = JSON.parse(
                configResponse.data.results[0].configuration
            )
            store.commit('locale/changeLocale', config.locale)
        }
    },

    async logout() {
        await session.removeSession()
    },

    async forgotPassword(parameters) {
        return requester.post(`${BACKEND_API_V1_URL}/users/forgot`, parameters)
    },

    async resetPassword(parameters) {
        return requester.post(`${BACKEND_API_V1_URL}/users/reset`, parameters)
    },
}
